import LoadingSkeleton from 'common-components/LoadingSkeleton'
import { AudioCirclePlayer } from '../../audio-circle-player'

import * as Styled from './styled'
import SoundListItemInfo from './info'
import { SoundListItemAddButton } from './add-button'
import SoundListItemDeleteButton from './delete-button'
import { IUserAudio } from 'store/types/audio'

interface IProps {
  sound: IUserAudio
  isDeletingSound: boolean
  isShowSoundDeleteBtn?: boolean
  currentPlayingAudioRef: React.MutableRefObject<HTMLAudioElement | null>
  onDeleteIconClick: (id: number) => void
  onClickAddButton: (() => void) | undefined
  isDisableDeleteBtn?: boolean
  isLoadingState?: boolean
}

const AUDIO_MIN_DURATION = 1

export const SoundListItem: React.FC<IProps> = ({
  sound,
  isShowSoundDeleteBtn,
  isDeletingSound,
  onDeleteIconClick,
  currentPlayingAudioRef,
  onClickAddButton,
  isDisableDeleteBtn = false,
  isLoadingState
}) => {
  const { path, title, duration, id } = sound

  const isVerticalLineVisible = isShowSoundDeleteBtn

  if (isLoadingState) {
    return (
      <Styled.SoundListItemWrapper $isLoadingState={isLoadingState}>
        <LoadingSkeleton />
      </Styled.SoundListItemWrapper>
    )
  }

  return (
    <Styled.SoundListItemWrapper $isDisable={isDeletingSound}>
      <Styled.SoundListItemSidesWrapper>
        <AudioCirclePlayer
          src={path}
          currentPlayingAudioRef={currentPlayingAudioRef}
        />

        <SoundListItemInfo title={title} duration={duration} />
      </Styled.SoundListItemSidesWrapper>

      <Styled.SoundListItemSidesWrapper>
        {isVerticalLineVisible && <Styled.VerticalLine />}

        {isShowSoundDeleteBtn && !isDisableDeleteBtn && (
          <SoundListItemDeleteButton
            onDeleteIconClick={onDeleteIconClick}
            id={id}
          />
        )}
        {sound.duration >= AUDIO_MIN_DURATION && (
          <SoundListItemAddButton
            sound={sound}
            onClickAddButton={onClickAddButton}
          />
        )}
      </Styled.SoundListItemSidesWrapper>
    </Styled.SoundListItemWrapper>
  )
}
